module.exports = __webpack_public_path__ + "img/IMG-20200229-WA0114.f6e09d59.jpg";